import * as yup from 'yup';

export const roomSchema = yup.object({
  roomNo: yup.string().required('Room Number Is required'),
  roomType: yup.string().required('Room Type Is required'),
  amount: yup
    .number()
    .transform((value, originalValue) => (originalValue === '' ? null : value))
    .nullable(),
  partialAmount: yup
    .number()
    .transform((value, originalValue) => (originalValue === '' ? null : value))
    .nullable()
});
